/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc
 */

export const getVideoByVideoIdRpc = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'getVideoByVideoId',
  auth: 'app',
  fingerprint: 'BsBxm9pdnfHRmRJkYrQtTCsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCrmVideoByVideoIdRpc = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'getCrmVideoByVideoId',
  auth: 'app',
  fingerprint: 'BsBxm9pdnfH1TwFLzVruTisLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getVideosByVideoIdsRpc = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'getVideosByVideoIds',
  auth: 'app',
  fingerprint: 'TCtE7lZ6pEYd1nhSErGuQCsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getVideoByFileIdRpc = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'getVideoByFileId',
  auth: 'app',
  fingerprint: 'ATWAZeIns-nRmRJkYrQtTCsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getVideosByFileIdsBulkRpc = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'getVideosByFileIdsBulk',
  auth: 'app',
  fingerprint: 'PtmECGKy_gwd1nhSErGuQCsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getVideosByFileIdsPagedRpc = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'getVideosByFileIdsPaged',
  auth: 'app',
  fingerprint: 'xrkFsssajwUksR7XIuYqWysLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getVideoByCrmIdRpc = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'getVideoByCrmId',
  auth: 'app',
  fingerprint: 'srIQeYJROEbRmRJkYrQtTCsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const softDeleteVideoByFileIdRpc = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'softDeleteVideoByFileId',
  auth: 'app',
  fingerprint: 'ATWAZeIns-m0zRsL6R_-pysLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const softDeleteVideosByFileIdsBulkRpc = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'softDeleteVideosByFileIdsBulk',
  auth: 'app',
  fingerprint: 'PtmECGKy_gy0zRsL6R_-pysLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const hardDeleteVideoByFileIdRpc = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'hardDeleteVideoByFileId',
  auth: 'app',
  fingerprint: 'ATWAZeIns-m0zRsL6R_-pysLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateVideoByFileIdRpc = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'updateVideoByFileId',
  auth: 'app',
  fingerprint: 'TKZWR_XohOHRmRJkYrQtTCsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const setThumbnailRpc = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'setThumbnail',
  auth: 'app',
  fingerprint: 'obPSK1r8C0zRmRJkYrQtTCsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateVideoEmbeddabilityRpc = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'updateVideoEmbeddability',
  auth: 'app',
  fingerprint: 'QeTw4qLrrTPRmRJkYrQtTCsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateVideoVisibilityRpc = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'updateVideoVisibility',
  auth: 'app',
  fingerprint: 'fdvXvRhNl6DRmRJkYrQtTCsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getVideoLimitInfoRpc = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'getVideoLimitInfo',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADvzvuCIdRzXSsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getVideoLimitInfoForDisplayRpc = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'getVideoLimitInfoForDisplay',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADvzvuCIdRzXSsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOrCreateShareKeyRpc = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'getOrCreateShareKey',
  auth: 'app',
  fingerprint: 'cO_e4JOmF61VXyZd6ICrtCsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const resolveShareKeyRpc = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'resolveShareKey',
  auth: 'app',
  fingerprint: 'vi_TH49Wy59VXyZd6ICrtCsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSignedTranscriptsRpc = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'getSignedTranscripts',
  auth: 'app',
  fingerprint: 'S7OsslMCJMST9V1Krju9RCsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPreviewPlayerRpc = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'getPreviewPlayer',
  auth: 'app',
  fingerprint: 'P5_qusteyqQFrGtjMucrfSsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};